"use client"

import { useEffect, useRef, type DependencyList } from "react"

import type { CartLineItemPayload } from "~/providers/GTMTrackingProvider/constants"
import { useGlobalTrackingProps } from "~/providers/GTMTrackingProvider/hooks/use-get-tracking-globals"
import { useTracking } from "~/providers/GTMTrackingProvider/hooks/use-tracking"

type ClientViewItemProps = {
  payload: CartLineItemPayload
  deps?: DependencyList
}

export function ClientViewItem({ payload, deps = [] }: ClientViewItemProps) {
  const { sendEvent } = useTracking()
  const globalTrackingProps = useGlobalTrackingProps("Product Page")
  const currentDeps = useRef<DependencyList>()

  useEffect(() => {
    if (currentDeps.current?.[0] !== deps?.[0]) {
      currentDeps.current = [...deps]
      sendEvent("view_item", { ecommerce: { ...globalTrackingProps, items: [payload] } })
    }
  }, deps)

  return null
}
